import React, { useEffect, useRef, useState } from 'react';
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi';
import { toast } from 'react-toastify';
import Wrapper from '../Wrapper';
import Input from '../../components/Input';
import moment from 'moment';
import Modal from '../../components/modal';
import { MdClose } from 'react-icons/md';

const AdminAttendance = () => {
  const [selectedDays, setSelectedDays] = useState([]);

  console.log(selectedDays);

  const [selectedDate, setSelectedDate] = useState(new Date().toISOString().split('T')[0]);
  const [dateRange, setDateRange] = useState([]);
  const [attendanceData, setAttendanceData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [error, setError] = useState(null);
  const [currentMonth, setCurrentMonth] = useState(new Date().getMonth());
  const [currentYear, setCurrentYear] = useState(new Date().getFullYear());
  const containerRef = useRef(null);
  const [attendanceLoading, setAttendanceLoading] = useState({});

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalSkip, setIsModalSkip] = useState(false);
  const [isModalAbsent, setIsModalAbsent] = useState(false);
  const [isModalAbsentSecond, setIsModalAbsentSecond] = useState(false);
  const [holdStartDate, setHoldStartDate] = useState(moment().format('YYYY-MM-DD'));
  const [holdEndDate, setHoldEndDate] = useState('');
  const [remarks, setRemarks] = useState('');
  const [selectedStudent, setSelectedStudent] = useState(null);
  const [selectedStudentSkip, setSelectedStudentSkip] = useState(null);
  const [selectedAbsentStudent, setSelectedAbsentStudent] = useState(null);
  const [teacherId, setTeacherId] = useState('');

  const scroll = (direction) => {
    const container = containerRef.current;
    const scrollAmount = direction === 'left' ? -150 : 150;
    container.scrollBy({ left: scrollAmount, behavior: 'smooth' });
  };

  const getDaysInMonth = (year, month) => {
    return new Date(year, month + 1, 0).getDate();
  };

  const generateDateRange = (year, month) => {
    const daysInMonth = getDaysInMonth(year, month);
    const dateRange = [];
    for (let i = 1; i <= daysInMonth; i++) {
      dateRange.push({
        DATE: i,
        month: new Date(year, month, i).toLocaleString('default', { month: 'short' })
      });
    }
    return dateRange;
  };

  useEffect(() => {
    const newDateRange = generateDateRange(currentYear, currentMonth);
    setDateRange(newDateRange);
    setLoading(false);
  }, [currentMonth, currentYear]);

  const userDetails = localStorage.getItem('userData');
  const userData = JSON.parse(userDetails);

  useEffect(() => {
    if (selectedDate && !isNaN(new Date(selectedDate).getTime())) {
      fetchAttendanceData();
    }
  }, [selectedDate, currentPage]);

  const fetchAttendanceData = async () => {
    setLoading(true);
    setError(null);

    try {
      const response = await fetch(
        `https://quran-backend-theta.vercel.app/v1/admin/all-attendence?date=${selectedDate}&page=${currentPage}&limit=10`
      );
      const result = await response.json();
      console.log(result);

      if (result?.success === false) {
        setError(result?.attendance);
      } else if (result?.success === true) {
        setAttendanceData(result?.data);
        setTotalPages(result?.totalPages || 1);
      }
    } catch (error) {
      console.error(error);
      setError('Failed to fetch attendance data.');
    } finally {
      setLoading(false);
    }
  };

  const handleMonthChange = (direction) => {
    let newMonth = currentMonth;
    let newYear = currentYear;

    if (direction === 'left') {
      if (currentMonth === 0) {
        newMonth = 11;
        newYear = currentYear - 1;
      } else {
        newMonth = currentMonth - 1;
      }
    } else {
      if (currentMonth === 11) {
        newMonth = 0;
        newYear = currentYear + 1;
      } else {
        newMonth = currentMonth + 1;
      }
    }
    setCurrentMonth(newMonth);
    setCurrentYear(newYear);
    const newDate = new Date(newYear, newMonth, 1).toISOString().split('T')[0];
    setSelectedDate(newDate);
  };

  const clearSelectedDate = () => {
    setSelectedDate(new Date().toISOString().split('T')[0]);
    setCurrentMonth(new Date().getMonth());
    setCurrentYear(new Date().getFullYear());
  };

  const handleSelectChangeSecond = (event, studentId, course) => {
    const value = event.target.value;
    if (value === 'Absent') {
      setSelectedAbsentStudent({ studentId, course });
      setIsModalAbsentSecond(true);
      return;
    }
    setTeacherId(teacherId);
    updateAttendanceScond(studentId, course, value, teacherId);
  };

  const handleSelectChange = (event, studentId, course, session, teacherId) => {
    const value = event.target.value;
    setTeacherId(teacherId);

    if (value === 'Hold') {
      setSelectedStudent({ studentId, course, session });
      setIsModalOpen(true);
      return;
    }
    if (value === 'Absent') {
      setSelectedStudent({ studentId, course, session });
      setIsModalAbsent(true);
      return;
    }
    if (value === 'Skip') {
      setSelectedStudentSkip({ studentId, course, session });
      setIsModalSkip(true);
      return;
    }
    updateAttendance(studentId, course, session, value, teacherId);
  };

  const updateAttendance = async (
    studentId,
    course,
    session,
    status,
    teacherId,
    holdStartDate = null,
    holdEndDate = null
  ) => {
    setAttendanceLoading((prev) => ({ ...prev, [studentId]: true }));

    try {
      const response = await fetch(
        'https://quran-backend-theta.vercel.app/v1/admin/mark-attendence-admin',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            courseId: course,
            studentId: studentId,
            teacherId: teacherId,
            status: status,
            sessionTime: session,
            remarks: status === 'Hold' || status === 'Absent' ? remarks : '',
            holdStartDate: holdStartDate ? moment(holdStartDate).format('YYYY-MM-DD') : undefined,
            holdEndDate: holdEndDate ? moment(holdEndDate).format('YYYY-MM-DD') : undefined,
            date: moment(selectedDate).format('YYYY-MM-DD')
          })
        }
      );

      const data = await response.json();
      if (data?.success === false) {
        toast.error(data?.message);
      } else {
        toast.success('Attendance updated successfully!');
      }
      fetchAttendanceData();
    } catch (error) {
      toast.error('Failed to update attendance.', error);
    } finally {
      setAttendanceLoading((prev) => ({ ...prev, [studentId]: false }));
    }
  };

  const updateAttendanceSkip = async (
    studentId,
    course,
    session,
    status,
    teacherId,
    holdStartDate = null,
    holdEndDate = null
  ) => {
    setAttendanceLoading((prev) => ({ ...prev, [studentId]: true }));

    try {
      const response = await fetch(
        'https://quran-backend-theta.vercel.app/v1/admin/mark-attendence-admin',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            courseId: course,
            studentId: studentId,
            teacherId: teacherId,
            status: status,
            sessionTime: session,
            skipDays: selectedDays,
            remarks: status === 'Skip' ? remarks : '',
            skipStartDate: holdStartDate ? moment(holdStartDate).format('YYYY-MM-DD') : undefined,
            skipEndDate: holdEndDate ? moment(holdEndDate).format('YYYY-MM-DD') : undefined,
            date: moment(selectedDate).format('YYYY-MM-DD')
          })
        }
      );

      const data = await response.json();
      if (data?.success === false) {
        toast.error(data?.message);
      } else {
        toast.success('Attendance updated successfully!');
      }
      fetchAttendanceData();
    } catch (error) {
      toast.error('Failed to update attendance.', error);
    } finally {
      setAttendanceLoading((prev) => ({ ...prev, [studentId]: false }));
    }
  };

  const updateAttendanceScond = async (studentId, course, status) => {
    setAttendanceLoading((prev) => ({ ...prev, [studentId]: true }));

    try {
      const response = await fetch(
        'https://quran-backend-theta.vercel.app/v1/admin/update-attendence-status',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            attendanceId: course,
            newStatus: status,
            remarks: remarks
          })
        }
      );

      const data = await response.json();
      if (data?.success === false) {
        toast.error(data?.message);
      } else {
        toast.success('Attendance updated successfully!');
      }
      fetchAttendanceData();
    } catch (error) {
      toast.error('Failed to update attendance.', error);
    } finally {
      setAttendanceLoading((prev) => ({ ...prev, [studentId]: false }));
    }
  };

  const handleSaveHold = () => {
    if (!holdStartDate || !holdEndDate) {
      toast.error('Please select both start and end dates for hold.');
      return;
    }
    const { studentId, course, session } = selectedStudent;
    updateAttendance(studentId, course, session, 'Hold', teacherId, holdStartDate, holdEndDate);
    setIsModalOpen(false);
    setHoldStartDate(moment().format('YYYY-MM-DD'));
    setHoldEndDate('');
    setRemarks('');
    setSelectedStudent(null);
  };

  const handleSaveSkip = () => {
    if (!holdStartDate || !holdEndDate || !selectedDays?.length === 0 || !remarks) {
      toast.error('Please select both start and end dates for hold.');
      return;
    }
    const { studentId, course, session } = selectedStudentSkip;
    updateAttendanceSkip(studentId, course, session, 'Skip', teacherId, holdStartDate, holdEndDate);
    setIsModalSkip(false);
    setHoldStartDate(moment().format('YYYY-MM-DD'));
    setHoldEndDate('');
    setRemarks('');
    setSelectedStudentSkip(null);
  };

  const handleSaveAbsent = () => {
    const { studentId, course, session } = selectedStudent;
    updateAttendance(studentId, course, session, 'Absent', teacherId, holdStartDate, holdEndDate);
    setIsModalAbsent(false);
    setHoldStartDate(moment().format('YYYY-MM-DD'));
    setHoldEndDate('');
    setRemarks('');
    setSelectedStudent(null);
  };

  const handleSaveAbsentSecond = () => {
    const { studentId, course } = selectedAbsentStudent;
    updateAttendanceScond(studentId, course, 'Absent');
    setIsModalAbsentSecond(false);
    setHoldStartDate(moment().format('YYYY-MM-DD'));
    setHoldEndDate('');
    setRemarks('');
    setSelectedStudent(null);
  };

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      setCurrentPage(newPage);
    }
  };

  const currentDateRef = useRef(null);

  useEffect(() => {
    if (currentDateRef.current) {
      currentDateRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        inline: 'center'
      });
    }
  }, [dateRange]);

  return (
    <Wrapper>
      <div className="flex justify-between items-center mb-4">
        <Input
          type={'date'}
          value={selectedDate}
          className={'w-96 p-2'}
          onChange={(e) => setSelectedDate(e.target.value)}
        />
        <button
          onClick={clearSelectedDate}
          className="ml-4 p-2 bg-red-500 text-white rounded-md hover:bg-red-600">
          Clear
        </button>
      </div>
      <div className="flex justify-between items-center space-x-2 px-3 bg-[#D9D9D942] rounded-md">
        <button
          onClick={() => handleMonthChange('left')}
          className="text-white bg-primary rounded-full hover:bg-orange">
          <FiChevronLeft className="w-6 h-6" />
        </button>

        <div className="flex overflow-x-auto space-x-2 py-2" ref={containerRef}>
          {dateRange.map((date, index) => {
            const dateString = `${currentYear}-${String(currentMonth + 1).padStart(2, '0')}-${String(date.DATE).padStart(2, '0')}`;
            const isCurrentDate = dateString === selectedDate;
            return (
              <button
                key={index}
                ref={isCurrentDate ? currentDateRef : null}
                onClick={() => setSelectedDate(dateString)}
                className={`flex flex-col items-center px-6 py-2 ${
                  isCurrentDate
                    ? ' bg-orange text-white font-bold'
                    : 'text-gray-800 hover:bg-gray-200'
                }`}>
                {date.DATE} {date.month}
              </button>
            );
          })}
        </div>
        <button
          onClick={() => handleMonthChange('right')}
          className="text-white bg-primary rounded-full hover:bg-orange">
          <FiChevronRight className="w-6 h-6" />
        </button>
      </div>

      <section className="mb-20 mt-7">
        <div className="rounded-lg overflow-x-auto">
          <div className="flex flex-col">
            <div className="sm:-mx-6 lg:-mx-8">
              <div className="inline-block min-w-full sm:px-6 lg:px-8">
                <div className="overflow-hidden">
                  {loading ? (
                    <div className="flex justify-center items-center h-32">
                      <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
                    </div>
                  ) : error ? (
                    <div className="text-center text-red-500 py-4">{error}</div>
                  ) : (
                    <>
                      {attendanceData?.length > 0 ? (
                        <>
                          <table className="min-w-full mb-0">
                            <thead className="">
                              <tr className="rounded-lg whitespace-nowrap">
                                <th
                                  scope="col"
                                  className="text-sm text-primary font-bold px-6 py-4">
                                  Sr No.
                                </th>
                                <th
                                  scope="col"
                                  className="text-sm text-primary font-bold px-6 py-4">
                                  ID
                                </th>
                                <th
                                  scope="col"
                                  className="text-sm text-primary font-bold px-6 py-4">
                                  Student
                                </th>
                                <th
                                  scope="col"
                                  className="text-sm text-primary font-bold px-6 py-4">
                                  Course
                                </th>

                                <th
                                  scope="col"
                                  className="text-sm text-primary font-bold px-6 py-4">
                                  Timing
                                </th>

                                <th
                                  scope="col"
                                  className="text-sm text-primary font-bold px-6 py-4">
                                  Remarks
                                </th>

                                <th
                                  scope="col"
                                  className="text-sm text-primary font-bold px-6 py-4">
                                  Mark Attendance
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {attendanceData?.map((record, index) => (
                                <tr
                                  key={record._id}
                                  className="bg-white border-b-8 border-white rounded-md">
                                  <td className="align-middle bg-white text-sm font-normal px-6 py-3 whitespace-nowrap text-center">
                                    <span className="bg-white text-base text-black py-1 px-2.5 leading-none text-center whitespace-nowrap align-baseline bg-green-200 rounded-full">
                                      {`${index + 1}`}
                                    </span>
                                  </td>

                                  <td className="align-middle bg-white text-sm font-normal px-6 py-3 whitespace-nowrap text-center">
                                    <span className="bg-white text-base text-black py-1 px-2.5 leading-none text-center whitespace-nowrap align-baseline bg-green-200 rounded-full">
                                      {record?.userDetails?.studentId}
                                    </span>
                                  </td>

                                  <td className="align-middle bg-white text-sm font-normal px-6 py-3 text-center">
                                    <span className="bg-white text-base text-black py-1 px-2.5 leading-none text-center whitespace-nowrap align-baseline bg-green-200 rounded-full">
                                      {record.userDetails?.name}
                                    </span>
                                  </td>
                                  <td className="text-sm bg-white font-normal text-center px-6 py-4 whitespace-nowrap">
                                    <span className="text-base text-black py-1 px-2.5 leading-none text-center whitespace-nowrap align-baseline bg-green-200 rounded-full">
                                      {record?.course?.name}
                                    </span>
                                  </td>

                                  <td className="align-middle bg-white text-center text-sm font-normal px-6 py-4 whitespace-nowrap text-left">
                                    {record?.attendance?.map((item, index) => {
                                      return (
                                        <span
                                          key={index}
                                          className="text-base text-black py-1 px-2.5 bg-green-200 rounded-full">
                                          {item?.timeSlot?.startTime} - {item?.timeSlot?.endTime}
                                        </span>
                                      );
                                    })}
                                  </td>

                                  <td className="text-sm bg-white font-normal text-center px-6 py-4 whitespace-nowrap">
                                    <span className="text-base text-black py-1 px-2.5 leading-none text-center whitespace-nowrap align-baseline bg-green-200 rounded-full">
                                      {record?.attendanceRemarks ? record?.attendanceRemarks : '-'}
                                    </span>
                                  </td>

                                  <td className="align-middle bg-white text-center text-sm font-normal px-6 py-4 whitespace-nowrap text-left">
  {attendanceLoading[record?.userDetails?._id] ? (
    <div className="text-[gray] bg-[#3FFF801F] px-3 py-2 mx-auto w-24 rounded-md">
      Loading...
    </div>
  ) : (
    // If no attendance marked yet or status is '-'
    record?.todayAttendance === '-' || !record?.todayAttendance ? (
      <select
        onChange={(e) => handleSelectChange(
          e,
          record?.userDetails?._id,
          record?.course?._id,
          record?.attendance?.[0]?.timeSlots,
          record?.assignedTeacher?._id
        )}
        className={`text-sm mx-auto py-1 rounded-md bg-gray-200 px-3 py-2 rounded-md`}
        defaultValue={'Select'}
      >
        <option value="Select" disabled>Select</option>
        <option value="Present">Present</option>
        <option value="Absent">Absent</option>
        <option value="Leave">Leave</option>
        <option value="Hold">Hold</option>
        <option value="Skip">Skip</option>
      </select>
    ) : (
      // If attendance is already marked
      <select
        onChange={(e) => handleSelectChangeSecond(
          e,
          record?.userDetails?._id,
          record?.attendance?.[0]?.id
        )}
        className={`text-sm mx-auto py-1 px-3 rounded-md ${
          record?.todayAttendance === 'Present'
            ? 'bg-[#DFF7E3] text-[#23A118]'
            : record?.todayAttendance === 'Absent'
              ? 'bg-[#FFE4E4] text-[#FF0000]'
              : record?.todayAttendance === 'Leave'
                ? 'bg-[#E0F7FA] text-[#00BCD4]'
                : record?.todayAttendance === 'Hold'
                  ? 'bg-[#FFF3E0] text-[#FFA500]'
                  : record?.todayAttendance === 'Skip'
                    ? 'bg-[#F5F0FF] text-[#7E5BEF]'
                    : 'bg-gray-200 text-black'
        } px-3 py-2 rounded-md`}
        defaultValue={record?.todayAttendance}
        disabled={record?.todayAttendance === 'Hold' || record?.todayAttendance === 'Skip'}
      >
        <option value={record?.todayAttendance} selected>
          {record?.todayAttendance}
        </option>
        {!(record?.todayAttendance === 'Hold' || record?.todayAttendance === 'Skip') && (
          <>
            <option value="Present">Present</option>
            <option value="Absent">Absent</option>
            <option value="Leave">Leave</option>
          </>
        )}
      </select>
    )
  )}
</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </>
                      ) : (
                        <tr>
                          <td colSpan="5" className="text-center text-sm font-normal py-4">
                            No attendance records available
                          </td>
                        </tr>
                      )}
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="flex justify-end mt-4 items-center">
          <button
            onClick={() => handlePageChange(currentPage - 1)}
            disabled={currentPage === 1}
            className="px-4 py-2 bg-gray-200 text-gray-700 cursor-pointer rounded hover:bg-gray-300 disabled:opacity-50 disabled:cursor-not-allowed">
            Previous
          </button>

          <span className="mx-4 py-2">
            Page {currentPage} of {totalPages}
          </span>

          <select
            value={currentPage}
            onChange={(e) => handlePageChange(Number(e.target.value))}
            className="mx-2 px-3 py-2 border rounded bg-white">
            {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
              <option key={page} value={page}>
                {page}
              </option>
            ))}
          </select>

          <button
            onClick={() => handlePageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
            className="px-4 py-2 bg-gray-200 text-gray-700 cursor-pointer rounded hover:bg-gray-300 disabled:opacity-50 disabled:cursor-not-allowed">
            Next
          </button>
        </div>

        {/* Modal for Hold Attendance */}
        <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>
          <div className="p-3 flex justify-between items-center">
            <span></span>
            <h1 className="capitalize h4 font-medium">Hold Attendance</h1>
            <MdClose onClick={() => setIsModalOpen(false)} size={25} className="cursor-pointer" />
          </div>
          <hr />
          <div className="p-5">
            <form className="flex justify-between flex-wrap items-center">
              <div className="w-[48%]">
                <Input
                  type={'date'}
                  label={'Hold Start Date'}
                  placeholder={''}
                  className={'bg-gray-100 px-2 w-full'}
                  name="holdStartDate"
                  value={holdStartDate}
                  onChange={(e) => setHoldStartDate(e.target.value)}
                  min={moment().format('YYYY-MM-DD')}
                />
              </div>
              <div className="w-[48%]">
                <Input
                  type={'date'}
                  label={'Hold End Date'}
                  placeholder={''}
                  className={'bg-gray-100 px-2 w-full'}
                  name="holdEndDate"
                  value={holdEndDate}
                  onChange={(e) => setHoldEndDate(e.target.value)}
                  min={holdStartDate || moment().format('YYYY-MM-DD')}
                />
              </div>
              <div className="w-full mt-4">
                <label className="block text-sm font-medium text-gray-700 mb-1">Remarks</label>
                <textarea
                  rows={4}
                  name="remarks"
                  className="bg-gray-100 px-2 w-full outline-none py-3.5 text-black placeholder:text-primary rounded-md"
                  value={remarks}
                  onChange={(e) => setRemarks(e.target.value)}
                  placeholder="Enter remarks (required for Hold status)"
                />
              </div>
            </form>
            <div className="flex justify-center items-center mt-4">
              <button
                onClick={handleSaveHold}
                className="bg-secondary w-60 mx-auto text-white px-4 py-2 rounded-md hover:bg-orange disabled:opacity-50"
                disabled={!holdStartDate || !holdEndDate || !remarks}>
                Save
              </button>
            </div>
          </div>
        </Modal>

        <Modal isOpen={isModalAbsent} onClose={() => setIsModalAbsent(false)}>
          <div className="p-3 flex justify-between items-center">
            <span></span>
            <h1 className="capitalize h4 font-medium">Absent Attendance</h1>
            <MdClose onClick={() => setIsModalAbsent(false)} size={25} className="cursor-pointer" />
          </div>
          <hr />
          <div className="p-5">
            <form className="flex justify-between flex-wrap items-center">
              <div className="w-full mt-4">
                <label className="block text-sm font-medium text-gray-700 mb-1">Remarks</label>
                <textarea
                  rows={4}
                  name="remarks"
                  className="bg-gray-100 px-2 w-full outline-none py-3.5 text-black placeholder:text-primary rounded-md"
                  value={remarks}
                  onChange={(e) => setRemarks(e.target.value)}
                  placeholder="Enter remarks (required for Hold status)"
                />
              </div>
            </form>
            <div className="flex justify-center items-center mt-4">
              <button
                onClick={handleSaveAbsent}
                className="bg-secondary w-60 mx-auto text-white px-4 py-2 rounded-md hover:bg-orange disabled:opacity-50"
                disabled={!remarks}>
                Save
              </button>
            </div>
          </div>
        </Modal>

        <Modal isOpen={isModalAbsentSecond} onClose={() => setIsModalAbsentSecond(false)}>
          <div className="p-3 flex justify-between items-center">
            <span></span>
            <h1 className="capitalize h4 font-medium">Absent Attendance</h1>

            <MdClose
              onClick={() => setIsModalAbsentSecond(false)}
              size={25}
              className="cursor-pointer"
            />
          </div>
          <hr />
          <div className="p-5">
            <form className="flex justify-between flex-wrap items-center">
              <div className="w-full mt-4">
                <label className="block text-sm font-medium text-gray-700 mb-1">Remarks</label>
                <textarea
                  rows={4}
                  name="remarks"
                  className="bg-gray-100 px-2 w-full outline-none py-3.5 text-black placeholder:text-primary rounded-md"
                  value={remarks}
                  onChange={(e) => setRemarks(e.target.value)}
                  placeholder="Enter remarks (required for Hold status)"
                />
              </div>
            </form>
            <div className="flex justify-center items-center mt-4">
              <button
                onClick={handleSaveAbsentSecond}
                className="bg-secondary w-60 mx-auto text-white px-4 py-2 rounded-md hover:bg-orange disabled:opacity-50"
                disabled={!remarks}>
                Save
              </button>
            </div>
          </div>
        </Modal>

        {/* Modal for Skip Attendance */}
        {/* Modal for Skip Attendance */}
        <Modal isOpen={isModalSkip} onClose={() => setIsModalSkip(false)}>
          <div className="p-3 flex justify-between items-center">
            <span></span>
            <h1 className="capitalize h4 font-medium">Hold Attendance</h1>
            <MdClose onClick={() => setIsModalSkip(false)} size={25} className="cursor-pointer" />
          </div>
          <hr />
          <div className="p-5">
            <form className="flex justify-between flex-wrap items-center">
              <div className="w-[48%]">
                <Input
                  type={'date'}
                  label={'Skip Start Date'}
                  placeholder={''}
                  className={'bg-gray-100 px-2 w-full'}
                  name="skipStartDate"
                  value={holdStartDate}
                  onChange={(e) => setHoldStartDate(e.target.value)}
                  min={moment().format('YYYY-MM-DD')}
                />
              </div>
              <div className="w-[48%]">
                <Input
                  type={'date'}
                  label={'Skip End Date'}
                  placeholder={''}
                  className={'bg-gray-100 px-2 w-full'}
                  name="skipEndDate"
                  value={holdEndDate}
                  onChange={(e) => setHoldEndDate(e.target.value)}
                  min={holdStartDate || moment().format('YYYY-MM-DD')}
                />
              </div>
              <div className="w-full pt-3">
                <label htmlFor="days" className="block mb-2 text-sm font-medium text-gray-900">
                  Days (Select multiple)
                </label>
                <select
                  multiple
                  id="days"
                  className="bg-gray-100 px-2 w-full outline-none py-2 text-black placeholder:text-primary rounded-md h-auto min-h-[42px]"
                  name="days"
                  value={selectedDays}
                  onChange={(e) => {
                    const selected = Array.from(e.target.selectedOptions).map(
                      (option) => option.value
                    );
                    setSelectedDays(selected);
                  }}
                  size={7} // Show all 7 options without scrolling
                >
                  {[
                    'Monday',
                    'Tuesday',
                    'Wednesday',
                    'Thursday',
                    'Friday',
                    'Saturday',
                    'Sunday'
                  ].map((day) => (
                    <option key={day} value={day} className="py-1 px-2 hover:bg-blue-100">
                      {day}
                    </option>
                  ))}
                </select>
                <small className="text-gray-500">
                  Click to select multiple days (use Shift/Ctrl for multiple)
                </small>
              </div>
              <div className="w-full mt-4">
                <label className="block text-sm font-medium text-gray-700 mb-1">Remarks</label>
                <textarea
                  rows={4}
                  name="remarks"
                  className="bg-gray-100 px-2 w-full outline-none py-3.5 text-black placeholder:text-primary rounded-md"
                  value={remarks}
                  onChange={(e) => setRemarks(e.target.value)}
                  placeholder="Enter remarks (required for Hold status)"
                />
              </div>
            </form>
            <div className="flex justify-center items-center mt-4">
              <button
                onClick={handleSaveSkip}
                className="bg-secondary w-60 mx-auto text-white px-4 py-2 rounded-md hover:bg-orange disabled:opacity-50"
                disabled={!holdStartDate || !holdEndDate || !remarks || selectedDays.length === 0}>
                Save
              </button>
            </div>
          </div>
        </Modal>
      </section>
    </Wrapper>
  );
};

export default AdminAttendance;
